import { PolicyDecisionActionTypes } from "@iddataweb/idw-common-ui/enums";
import { EntityStatusTypes } from "@enums/entity-status-types";
import { DeployedPolicyComponent } from "@idw-types/data/reference-data/generic";
import { AxnAttributeTypeField } from "@idw-types/data/reference-data/axn";
import { FormattedRpServiceConfigurationPolicyConfig, RpServiceConfigurationPolicyConfig } from "@idw-types/data/rp-service-configuration";
import { formatRpServiceConfigurationPolicyConfigDecisions} from "./rp-service-configuration-policy-config-decision-formatter";

// export const formatRpServiceConfigurationPolicyConfigs = (
//     policyConfigs: Array<RpServiceConfigurationPolicyConfig>,
//     deployedPolicyComponents: Array<DeployedPolicyComponent>,
//     axnAttributeTypeFields: Array<AxnAttributeTypeField>
// ): Array<FormattedRpServiceConfigurationPolicyConfig> => {
//     return policyConfigs.map(pc => formatRpServiceConfigurationPolicyConfig(
//         pc,
//         deployedPolicyComponents,
//         axnAttributeTypeFields
//     ));
// };

export const formatRpServiceConfigurationPolicyConfig = (
    policyConfig: RpServiceConfigurationPolicyConfig,
    deployedPolicyComponents: Array<DeployedPolicyComponent>,
    axnAttributeTypeFields: Array<AxnAttributeTypeField>
): FormattedRpServiceConfigurationPolicyConfig => {
    if (!policyConfig) {
        return null;
    }

    const decisions = formatRpServiceConfigurationPolicyConfigDecisions(
        policyConfig.decisions || [],
        deployedPolicyComponents,
        axnAttributeTypeFields
    );

    let defaultAction = (policyConfig.defaultAction || "").toLowerCase() as PolicyDecisionActionTypes;
    let defaultActionStepUpApiKey = null;

    if (defaultAction?.includes(PolicyDecisionActionTypes.OBLIGATION)) {
        const obligationStringArray = policyConfig.defaultAction.split(":");
        if (obligationStringArray.length > 1) {
            defaultActionStepUpApiKey = obligationStringArray[1];
        }
        defaultAction = PolicyDecisionActionTypes.OBLIGATION;
    }

    return {
        decisions: decisions,
        defaultAction: defaultAction,
        defaultActionStepUpApiKey: defaultActionStepUpApiKey,
        defaultActionRetries: policyConfig.defaultActionRetries,
        description: policyConfig.description,
        id: policyConfig.id,
        name: policyConfig.name,
        policyRetries: policyConfig.policyRetries,
        rpAXNServiceID: policyConfig.rpAXNServiceID,
        status: policyConfig.status || EntityStatusTypes.INACTIVE
    };
};